import React from "react";
import "./NameSection.css";

export const NameSection = (props) => {
  const handleClick = () => {
    props.sendData(0);
    props.userSetname(props.userName);
  };
  return (
    <>
      <h1 className="heading_text mt-5">
        لمساعدتك بأفضل طريقة سوف نسألك أسئلة بسيطة
      </h1>
      <div className="input_container mt-5">
        <input
          type="text"
          name="name"
          id="name"
          className="input_field"
          placeholder="ما هو اسمك؟"
          value={props.userName}
          onChange={(e) => props.userSetname(e.target.value)}
          autoFocus
          dir="rtl"
        />
        <button type="button" className="input_button" disabled={props.userName === "" ? true : false} onClick={()=>handleClick()}>
          المتابعة <i className="fa fa-long-arrow-right ms-2" aria-hidden="true"></i>
        </button>
      </div>
    </>
  );
};
